import { render, staticRenderFns } from "./workerTenant.vue?vue&type=template&id=36b6df88&"
import script from "./workerTenant.vue?vue&type=script&lang=js&"
export * from "./workerTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports